import React from "react";

export default function FormInput({ data, register, errors }) {
	const {
		label,
		type,
		registerName,
		//  required,
		errorMessage,
	} = data;

	return (
		<div className="input-container" key={label}>
			<label>{label}</label>

			<input
				type={type}
				{...register(registerName, {
					required: false,
				})}
			/>

			{errors.registerName &&
				(errorMessage !== "" ? (
					errorMessage
				) : (
					<span>This field is required</span>
				))}
		</div>
	);
}
